import { render, staticRenderFns } from "./StrikethroughButton.vue?vue&type=template&id=4b25dda4&"
import script from "./StrikethroughButton.vue?vue&type=script&lang=js&"
export * from "./StrikethroughButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports